var map = {
	"./navigation.de-CH.json": 1092,
	"./navigation.de-DE.json": 1093,
	"./navigation.en-CA.json": 1094,
	"./navigation.en-GB.json": 1095,
	"./navigation.en-IN.json": 1096,
	"./navigation.en-ME.json": 1097,
	"./navigation.en-US.json": 1098,
	"./navigation.es-EM.json": 1099,
	"./navigation.es-ES.json": 1100,
	"./navigation.fr-BE.json": 1101,
	"./navigation.fr-CA.json": 1102,
	"./navigation.fr-CH.json": 1103,
	"./navigation.nl-BE.json": 1104,
	"./navigation.nl-NL.json": 1105,
	"./navigation.pl-PL.json": 1106,
	"./navigation.pt-BR.json": 1107
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1091;